function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76cdff"
    },
    d: "M55.48,273.731c0,0,2.323,72.009,62.434,120.005c60.111,47.996,143.407,51.433,210.84,55.992 c67.432,4.559,119.226-33.614,127.032-91.318c7.806-57.704-43.72-74.643-71.677-140.329 c-27.956-65.686-25.469-87.277-84.622-127.677c-59.153-40.4-151.687-15.593-200.203,53.618 C50.769,213.233,55.48,273.731,55.48,273.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#76cdff"
    },
    d: "M55.48,273.731c0,0,2.323,72.009,62.434,120.005 c60.111,47.996,143.407,51.433,210.84,55.992c67.432,4.559,119.226-33.614,127.032-91.318 c7.806-57.704-43.72-74.643-71.677-140.329c-27.956-65.686-25.469-87.277-84.622-127.677 c-59.153-40.4-151.687-15.593-200.203,53.618C50.769,213.233,55.48,273.731,55.48,273.731z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Padlock"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M83.612,179.686v-25.767c0-18.24,15.157-33.079,33.787-33.079c18.63,0,33.787,14.839,33.787,33.079v25.767h13.47v-25.767 c0-25.511-21.199-46.266-47.257-46.266s-47.257,20.755-47.257,46.266v25.767H83.612z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.137,
    y: 179.872,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 103.182,
    height: 85.354
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M127.458,215.317c0-6.074-5.029-10.997-11.233-10.997c-6.204,0-11.233,4.924-11.233,10.997c0,4.184,2.386,7.821,5.899,9.68 l-1.887,19.386h14.443l-1.887-19.386C125.071,223.137,127.458,219.501,127.458,215.317z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 232.637,267.988 206.952,266.298 206.952,265.883 203.794,266.09 200.636,265.883 200.636,266.298 174.951,267.988  156.002,423.785 174.951,423.785 203.162,299.568 204.425,299.568 232.637,423.785 251.586,423.785  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M156.002,423.785l-4.632,7.158l-14.316,6.316c0,0-2.526,1.263-2.526,4.211s0,5.474,0,5.474h40.844c0,0,0.421-4.632,0-8.842 c-0.421-4.211-0.421-14.316-0.421-14.316H156.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.528,442.312c0,2.57,0,4.632,0,4.632h40.844c0,0,0.184-2.036,0.186-4.632H134.528z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M251.508,423.785l4.632,7.158l14.316,6.316c0,0,2.526,1.263,2.526,4.211s0,5.474,0,5.474h-40.844c0,0-0.421-4.632,0-8.842 c0.421-4.211,0.421-14.316,0.421-14.316H251.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M272.983,442.312c0,2.57,0,4.632,0,4.632h-40.844c0,0-0.184-2.036-0.186-4.632H272.983z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M164.072,195.509c0,0-29.965,42.161-29.965,45.249s4.772,26.949,12.351,29.194c7.579,2.246,11.79-1.684,13.194-9.544 c1.404-7.86-3.369-19.089-3.369-19.089l14.036-12.632L164.072,195.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M158.248,259.286c0,0,8.702-1.404,10.948-0.842c2.246,0.561,3.93,5.895,3.93,5.895s0.842,7.86-0.562,9.544 c-1.404,1.684-8.141,3.649-10.948,4.211c-2.807,0.561-8.702-5.895-10.948-9.825C148.423,264.339,152.353,257.602,158.248,259.286z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 170.381,193.597 164.072,195.509 174.014,261.854 233.093,261.854 242.08,195.892 234.049,192.833 204.414,186.332  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 236.344,215.776 235.005,225.336 224.681,227.822 214.165,223.615 214.93,215.011  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M223.534,223.52c0-1.003,0.813-1.816,1.816-1.816c1.003,0,1.816,0.813,1.816,1.816c0,1.003-0.813,1.816-1.816,1.816 C224.347,225.336,223.534,224.523,223.534,223.52z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 198.104,198.568 203.649,205.069 196.575,250.192 204.032,262.046 212.827,249.618 205.37,205.26 211.679,199.142  204.988,190.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 192.751,187.288 167.322,193.597 168.087,196.656 192.942,189.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 213.591,186.523 239.021,192.833 238.256,195.892 213.4,189.009  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M239.021,192.833c0,0,9.618,2.17,15.512,5.538c5.895,3.369,7.299,10.948,3.93,19.369c-3.369,8.422-13.755,7.299-18.527,5.053 c-4.772-2.246-6.176-10.667-5.334-14.316"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 193.898,184.038 191.03,185.949 191.795,205.26 204.223,196.465 217.224,205.452 218.371,186.332 214.93,183.464  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M219.015,161.07c0,0,7.061-1.718,8.397-8.779c1.336-7.061-11.451-15.649-20.229-17.176c-8.779-1.527-21.756,7.634-23.855,13.931 c-2.099,6.298,6.107,12.596,14.886,13.932C206.992,164.314,219.015,161.07,219.015,161.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M192.679,162.215c0,0-3.817-5.916-4.771-0.763c-0.954,5.153,3.053,7.443,4.771,7.252 C194.397,168.513,192.679,162.215,192.679,162.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M217.489,162.215c0,0,3.817-5.916,4.771-0.763c0.954,5.153-3.053,7.443-4.771,7.252 C215.771,168.513,217.489,162.215,217.489,162.215z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 193.516,173.904 193.516,186.523 204.223,196.465 216.268,186.141 216.268,174.286  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M191.916,158.398c0,0-0.573,11.832,0.382,15.649c0.954,3.817,7.252,11.832,12.214,13.55c4.962,1.718,11.832-8.588,13.359-12.023 s0.954-17.939,0.954-17.939s-2.099-4.962-6.298-6.489C208.328,149.62,195.351,146.948,191.916,158.398z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.855,164.68c0,0.902-0.413,1.632-0.923,1.632c-0.51,0-0.923-0.731-0.923-1.632 c0-0.901,0.413-1.632,0.923-1.632C199.442,163.048,199.855,163.778,199.855,164.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M211.565,164.68c0,0.902-0.413,1.632-0.923,1.632c-0.509,0-0.923-0.731-0.923-1.632 c0-0.901,0.413-1.632,0.923-1.632C211.152,163.048,211.565,163.778,211.565,164.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M201.844,169.24c-0.86,0-1.557,0.558-1.557,1.246c0,0.688,0.697,1.246,1.557,1.246c0.434,0,0.825-0.142,1.108-0.371 c0.493,0.671,1.395,1.126,2.439,1.126c1.003,0,1.879-0.418,2.384-1.046c0.27,0.179,0.611,0.291,0.989,0.291 c0.86,0,1.557-0.558,1.557-1.246c0-0.688-0.697-1.246-1.557-1.246"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 203.364,
    y1: 177.073,
    x2: 207.352,
    y2: 177.073
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M191.48,161.273c0,0,0.142,3.832,1.419,2.839c1.277-0.994,1.703-7.523,0.568-8.374 C192.332,154.886,191.48,159.286,191.48,161.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M216.114,161.273c0,0,0.142,3.832,1.419,2.839c1.277-0.994,1.703-7.523,0.568-8.374 C216.966,154.886,216.114,159.286,216.114,161.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M191.48,158.151c0,0,0.431,0.345,0.423,0.517c1.847,1.002,6.099,2.843,12.978,3.215c5.905,0.319,10.965-1.78,13.97-3.427 c-0.016-0.515-0.027-0.818-0.027-0.82c-0.174-4.475-3.495-7.45-7.608-8.595c-3.931-1.095-8.445-0.909-12.24,0.61 c-1.964,0.786-3.751,1.972-5.063,3.648C193.477,153.855,190.783,157.592,191.48,158.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M191.916,158.398c0,0,4.771,1.336,12.977,0.954c8.206-0.382,13.919-0.953,13.919-0.953s-5.596,5.681-13.802,6.063 C196.14,164.874,191.916,158.398,191.916,158.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 170.955,215.776 172.293,225.336 182.618,227.822 193.133,223.615 192.369,215.011  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M183.765,223.52c0-1.003-0.813-1.816-1.816-1.816c-1.003,0-1.816,0.813-1.816,1.816c0,1.003,0.813,1.816,1.816,1.816 C182.952,225.336,183.765,224.523,183.765,223.52z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 173.126,
    y: 261.251,
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 60.634,
    height: 9.544
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M184.776,273.602h-13.194c-1.473,0-2.667-1.194-2.667-2.667v-6.457c0-1.473,1.194-2.667,2.667-2.667h13.194 c1.473,0,2.667,1.194,2.667,2.667v6.457C187.442,272.408,186.248,273.602,184.776,273.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M233.059,273.602h-13.194c-1.473,0-2.667-1.194-2.667-2.667v-6.457c0-1.473,1.194-2.667,2.667-2.667h13.194 c1.473,0,2.667,1.194,2.667,2.667v6.457C235.725,272.408,234.531,273.602,233.059,273.602z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.829,
    y: 261.812,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.194,
    height: 8.421
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M156.283,241.32c0,0-8.422-0.562-11.509-5.895"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 249.901,
    cy: 202.02,
    rx: 13.895,
    ry: 14.597
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 249.901,
    cy: 194.627,
    rx: 10.88,
    ry: 9.749
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 249.901,
    cy: 187.458,
    rx: 10.88,
    ry: 9.749
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M232.422,166.437c0,0,0.184,14.382,0.922,18.623c0.738,4.241,3.688,9.772,7.744,9.772c4.056,0,7.928-1.475,7.928-1.475 s4.794,2.581,9.404,1.844c4.61-0.738,3.872-7.191,3.872-9.957c0-2.766-0.553-23.601-0.553-23.601s0.369-2.028-1.475-2.397 c-1.844-0.369-2.766-0.369-2.766-0.369v-4.425c0,0-0.738-1.475-3.135-1.475c-2.397,0-2.581,0.553-2.581,0.553v-4.056 c0,0-1.993-3.23-4.61-1.659c-1.844,1.106-1.844,2.95-1.844,2.95l-0.184,3.872c0,0-4.425-1.66-4.794,0.922 c-0.369,2.581-1.106,18.439-1.106,18.439s-0.553-4.979-1.475-7.375C236.847,164.224,232.422,164.224,232.422,166.437z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 245.145,
    y1: 154.636,
    x2: 245.514,
    y2: 171.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 251.783,
    y1: 153.53,
    x2: 251.967,
    y2: 171.784
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 257.499,
    y1: 158.877,
    x2: 257.13,
    y2: 171.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 242.748,
    y1: 171.415,
    x2: 259.527,
    y2: 172.153
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M239.244,173.997c0,0-0.017,2.45,1.804,3.588c1.822,1.138,5.92,4.098,6.375,8.88"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.98,128.814v2.181h-5.327v7.757h6.542v2.211h-8.971v-21.806h8.971v2.211h-6.542v7.445H349.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M358.297,119.157c3.426,0,4.86,1.745,4.86,4.985v1.775c0,2.399-0.841,3.894-2.711,4.486 c1.994,0.592,2.741,2.213,2.741,4.548v3.396c0,0.965,0.031,1.869,0.436,2.616h-2.462c-0.279-0.623-0.404-1.184-0.404-2.648 v-3.426c0-2.462-1.154-3.24-3.179-3.24h-1.713v9.314h-2.429v-21.806H358.297z M357.674,129.438c1.931,0,3.084-0.624,3.084-2.991 v-2.087c0-1.962-0.717-2.991-2.523-2.991h-2.369v8.069H357.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.571,119.157c3.426,0,4.86,1.745,4.86,4.985v1.775c0,2.399-0.841,3.894-2.711,4.486 c1.994,0.592,2.741,2.213,2.741,4.548v3.396c0,0.965,0.032,1.869,0.437,2.616h-2.462c-0.279-0.623-0.404-1.184-0.404-2.648 v-3.426c0-2.462-1.153-3.24-3.179-3.24h-1.713v9.314h-2.429v-21.806H370.571z M369.948,129.438c1.931,0,3.084-0.624,3.084-2.991 v-2.087c0-1.962-0.717-2.991-2.523-2.991h-2.369v8.069H369.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M377.797,124.421c0-3.332,1.652-5.481,4.985-5.481c3.363,0,5.015,2.15,5.015,5.481v11.278 c0,3.302-1.652,5.482-5.015,5.482c-3.333,0-4.985-2.18-4.985-5.482V124.421z M380.196,135.824c0,1.994,0.842,3.146,2.586,3.146 c1.775,0,2.585-1.152,2.585-3.146v-11.527c0-1.962-0.81-3.146-2.585-3.146c-1.745,0-2.586,1.184-2.586,3.146V135.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M394.96,119.157c3.426,0,4.86,1.745,4.86,4.985v1.775c0,2.399-0.841,3.894-2.711,4.486 c1.994,0.592,2.741,2.213,2.741,4.548v3.396c0,0.965,0.031,1.869,0.437,2.616h-2.462c-0.279-0.623-0.404-1.184-0.404-2.648 v-3.426c0-2.462-1.154-3.24-3.179-3.24h-1.713v9.314h-2.429v-21.806H394.96z M394.338,129.438c1.931,0,3.084-0.624,3.084-2.991 v-2.087c0-1.962-0.717-2.991-2.523-2.991h-2.369v8.069H394.338z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M329.376,264.883v2.211h-5.016v9.439h-2.429v-21.806h8.659v2.211h-6.23v7.945H329.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M332.334,259.991c0-3.332,1.651-5.482,4.985-5.482c3.363,0,5.015,2.15,5.015,5.482v11.278 c0,3.302-1.652,5.482-5.015,5.482c-3.333,0-4.985-2.18-4.985-5.482V259.991z M334.733,271.393c0,1.994,0.841,3.146,2.586,3.146 c1.775,0,2.585-1.152,2.585-3.146v-11.527c0-1.962-0.81-3.146-2.585-3.146c-1.745,0-2.586,1.184-2.586,3.146V271.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.499,254.727c3.426,0,4.859,1.745,4.859,4.985v1.775c0,2.399-0.84,3.894-2.709,4.485 c1.994,0.592,2.741,2.213,2.741,4.548v3.396c0,0.965,0.031,1.869,0.437,2.616h-2.46c-0.281-0.623-0.405-1.184-0.405-2.648v-3.426 c0-2.462-1.154-3.24-3.179-3.24h-1.713v9.314h-2.429v-21.806H349.499z M348.876,265.007c1.931,0,3.084-0.624,3.084-2.991v-2.087 c0-1.962-0.717-2.991-2.523-2.991h-2.369v8.069H348.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M361.803,254.727c3.395,0,4.734,1.62,4.734,4.829v1.028c0,2.306-0.654,3.738-2.555,4.329 c2.118,0.592,2.928,2.274,2.928,4.673v1.838c0,3.272-1.589,5.109-4.984,5.109h-5.015v-21.806H361.803z M361.21,263.978 c1.932,0,2.928-0.623,2.928-2.897v-1.277c0-1.932-0.654-2.867-2.399-2.867h-2.399v7.04H361.21z M361.927,274.322 c1.776,0,2.585-0.935,2.585-2.96v-1.932c0-2.429-0.965-3.239-3.053-3.239h-2.118v8.131H361.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M371.552,254.727v21.806h-2.429v-21.806H371.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M379.153,254.727c3.396,0,4.953,2.057,4.953,5.42v10.997c0,3.332-1.557,5.389-4.953,5.389h-5.108 v-21.806H379.153z M379.122,274.322c1.745,0,2.586-1.091,2.586-3.084v-11.215c0-1.994-0.842-3.084-2.616-3.084h-2.618v17.384 H379.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M391.488,254.727c3.396,0,4.953,2.057,4.953,5.42v10.997c0,3.332-1.557,5.389-4.953,5.389h-5.108 v-21.806H391.488z M391.456,274.322c1.745,0,2.586-1.091,2.586-3.084v-11.215c0-1.994-0.841-3.084-2.616-3.084h-2.618v17.384 H391.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.471,264.383v2.181h-5.327v7.757h6.542v2.211h-8.971v-21.806h8.971v2.211h-6.542v7.445 H406.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M412.079,276.533h-2.18v-21.806h3.084l5.046,15.762v-15.762h2.15v21.806h-2.525l-5.576-17.631 V276.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.545,208.256l22.244-52.608h13.347v52.608h5.784v11.122h-5.784v14.126h-12.011v-14.126 h-23.579V208.256z M330.124,208.256v-29.251l-12.347,29.251H330.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M352.479,174.334c0-12.456,6.561-19.574,18.574-19.574c12.011,0,18.574,7.118,18.574,19.574 v40.485c0,12.456-6.563,19.574-18.574,19.574c-12.013,0-18.574-7.118-18.574-19.574V174.334z M364.713,215.598 c0,5.561,2.447,7.674,6.34,7.674c3.893,0,6.34-2.113,6.34-7.674v-42.042c0-5.561-2.447-7.674-6.34-7.674 c-3.893,0-6.34,2.113-6.34,7.674V215.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M421.103,174.78c0-7.007-2.447-8.898-6.34-8.898c-3.893,0-6.34,2.113-6.34,7.674v5.005h-11.567 v-4.227c0-12.456,6.227-19.574,18.24-19.574c12.011,0,18.24,7.118,18.24,19.574v2.002c0,8.343-2.67,13.57-8.565,16.016 c6.118,2.67,8.565,8.452,8.565,16.349v6.118c0,12.456-6.229,19.574-18.24,19.574c-12.013,0-18.24-7.118-18.24-19.574v-6.452 h11.567v7.23c0,5.561,2.447,7.674,6.34,7.674c3.893,0,6.34-1.891,6.34-8.786v-6.118c0-7.229-2.447-9.899-8.008-9.899h-4.116 v-11.122h4.782c4.561,0,7.341-2.002,7.341-8.231V174.78z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Security_Barrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    points: "86.871,446.504  72.614,446.504 91.623,313.986 105.88,313.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    points: "115.385,446.504  129.641,446.504 110.632,313.986 96.376,313.986  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    points: "289.182,446.504  274.925,446.504 293.934,313.986 308.191,313.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    points: "317.695,446.504  331.952,446.504 312.943,313.986 298.686,313.986  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.734,
    y: 293.209,
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    width: 271.927,
    height: 26.363
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.362,
    y: 293.209,
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    width: 271.927,
    height: 26.363
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "66.813,319.573 89.895,319.573 101.822,293.209 78.739,293.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "158.17,293.209 135.088,293.209 123.161,319.573 146.243,319.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "327.215,293.209 304.133,293.209 292.206,319.573 315.288,319.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "270.867,293.209 247.784,293.209 235.857,319.573 258.94,319.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "214.518,293.209 191.436,293.209 179.509,319.573 202.592,319.573  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    x1: 332.804,
    y1: 304.904,
    x2: 287.801,
    y2: 304.904
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    x1: 332.014,
    y1: 309.313,
    x2: 324.908,
    y2: 309.313
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    x1: 61.209,
    y1: 308.211,
    x2: 106.212,
    y2: 308.211
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeMiterlimit: 10
    },
    x1: 61.999,
    y1: 303.251,
    x2: 118.844,
    y2: 303.251
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.371,
    y: 440.719,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 77.139,
    height: 5.785
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 395.493,440.557 344.389,440.557 364.422,331.598 375.46,331.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 356.976,372.096 382.906,372.096 380.424,358.597 359.458,358.597  "
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 387.812,
    y1: 422.375,
    x2: 389.094,
    y2: 429.822
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#0041E8",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 373.223,
    y1: 337.618,
    x2: 386.198,
    y2: 412.995
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 450.01,
    y1: 446.504,
    x2: 456.923,
    y2: 446.504
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1663,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 39.372,
    y1: 446.504,
    x2: 440.364,
    y2: 446.504
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/error403.629f0b772c8d329663535bba55e3ae87.svg";
export { ForwardRef as ReactComponent };